import React from 'react';
import Loadable from 'react-loadable';

const ProjectSearchLazy = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
});

export default ProjectSearchLazy;
